
import React from 'react';
import ResultsPageView from './ResultsPageView';
import { voteResultsService } from '../_services';
import { toast } from 'react-toastify';
import ReactTooltip from 'react-tooltip';
import { history } from '../_helpers';
import { ROLES } from "../_constants/roles";

class ResultsPage extends React.Component {


    constructor() {
        super();
        this.toggleClass = this.toggleClass.bind(this);
        this.showManageDialog = this.showManageDialog.bind(this);
        this.hideManageDialog = this.hideManageDialog.bind(this);
        this.state = {
            judges: [],
            teams: [],
            loading: true,
            isOpened: false,
            notes: [],
            teamName: '',
            showReset: false,
            manageDialogOpen: false
        };
    }


    toggleClass(team) {
        const currentState = this.state.isOpened;

        this.setState({
            notes: team.notes,
            isOpened: !currentState,
            teamName: team.name
        });
    };

    resetVotes() {
        voteResultsService.resetVotes().then(() => {
            window.location.reload();
            toast("done!");
        },
            error => {
                toast("error!");
            })
    }

    componentDidMount() {
        let user = JSON.parse(localStorage.getItem('user'));
        var isJudge = user.roles.includes(ROLES.JUDGE);
        var isAdmin = user.roles.includes(ROLES.ADMIN);

        if (!isJudge && !isAdmin) {
            history.push("/no-access");
            return;
        } 

        var showReset = this.props.location.pathname.indexOf('reset') > -1;
        voteResultsService.getAll().then(
            data => {

                this.setState({
                    judges: data.judges,
                    teams: data.teamResults,
                    loading: false,
                    showReset: showReset
                }); 
                ReactTooltip.rebuild()
            },
            error => {
                toast("error!");
            }
        );

    }

    exportResults() {
        return voteResultsService.exportResults().then(async response => {
            try {                
                if (!response.ok) throw new Error('Network response was not ok');
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                // Try to get filename from Content-Disposition header, fallback to 'results.csv'
                const disposition = response.headers.get('Content-Disposition');
                let filename = 'results.pdf';

                if (disposition && disposition.indexOf('filename=') !== -1) {
                    // Split on ';' and look for the part that starts with 'filename='
                    const parts = disposition.split(';');
                    for (let part of parts) {
                        part = part.trim();
                        if (part.startsWith('filename=')) {
                            let value = part.substring('filename='.length).trim();
                            // Remove surrounding quotes if present
                            if (value.startsWith('"') && value.endsWith('"')) {
                                value = value.slice(1, -1);
                            }
                            filename = value;
                            break;
                        }
                    }
                }
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
                window.URL.revokeObjectURL(url);
            } catch (err) {
                alert('Failed to export results.');
            }
        });
    }

    showManageDialog(){
        this.setState({
            manageDialogOpen: true
        });
    }

    hideManageDialog(){
        this.setState({
            manageDialogOpen: false
        });
    }

    render() {
        return <ResultsPageView
            loading={this.state.loading}
            teamName={this.state.teamName}
            showReset={this.state.showReset}
            resetVotes={this.resetVotes}
            teams={this.state.teams}
            notes={this.state.notes}
            judges={this.state.judges}
            isOpened={this.state.isOpened}
            toggleClass={this.toggleClass}
            exportResults={this.exportResults}
            showManageDialog={this.showManageDialog}
            hideManageDialog={this.hideManageDialog}
            manageDialogOpen={this.state.manageDialogOpen} />;
            
    }
}

export { ResultsPage };
